import Article from "../../../../src/components/Article/Article";
import * as React from 'react';
export default {
  Article,
  React
};